import React from "react";

const ReviewItem = ({ review, active }) => {
    const { reviewContent } = review;

    return (
        <div className={"w-full flex-col h-full md:justify-center justify-start items-start gap-14 duration-1000 transition-opacity flex absolute top-0" + (active ? " opacity-100" : " opacity-0")}>
            <p className="md:text-lg text-base leading-loose pointer-events-none review-text">{reviewContent}</p>
        </div>
    );  
};

export default ReviewItem;
